import { ChevronFlip } from '@subaio/components'

import { Container } from './Container'
import { Spinner } from './Spinner'

type Props = {
	isMenuOpen: boolean
	isLoading: boolean
}

export const MenuIndicator = ({ isMenuOpen, isLoading }: Props) => (
	<Container>
		{isLoading ? <Spinner size={20} /> : <ChevronFlip isActive={!isMenuOpen} style={{ marginBottom: '3px' }} bold />}
	</Container>
)
